<div class="container-fluid admin-page">
  <span class="row-left1 pointer" (click)="goBack()">
    <mat-icon class="back-arrow-icon">arrow_back</mat-icon>
    <p class="text-b text-back-to-summary">Back to Summary</p>
  </span>
  <div class="d-flex justify-content-between align-items-center m-b-10">
    <div>
      <h5 class="m-0">Accounts &amp; Securities Review List</h5>
      <small class="field-note">* Required fields for Add / Edit</small>
    </div>
    <div class="admin-actions">
      <button type="button" class="export-button" (click)="exportToExcel()" [disabled]="!dataSource.data.length" title="Export to Excel">
        <object data="assets/img/rc-btn-secondary-icons8-excel.svg" class="rc-btn-secondary-icons8-excel" type="image/svg+xml"></object>
        <span>Export to Excel</span>
      </button>
      <button class="btn-primary hover-bright" (click)="startAddNew()" [disabled]="!!editingRow">
        <p class="btn-primary-label">Add</p>
        <img src="assets/img/btn-primary-icon.png" class="btn-primary-icon" alt="Add" />
      </button>
    </div>
  </div>

  <div class="table-scroll">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z1">

      <ng-container matColumnDef="referenceCode">
        <th mat-header-cell *matHeaderCellDef>Ref Code *</th>
        <td mat-cell *matCellDef="let row"
            [class.status-active]="row.isActive === 'Y'"
            [class.status-inactive]="row.isActive === 'N'">
          <mat-select *ngIf="isEditing(row); else view" [(ngModel)]="row.referenceCode" (ngModelChange)="onReferenceCodeChange(row)" [disabled]="!isNewRow" panelClass="refcode-select-panel" class="refcode-select">
            <mat-option *ngFor="let code of referenceCodes" [value]="code">{{ code }}</mat-option>
          </mat-select>
          <ng-template #view>{{ row.referenceCode }}</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="referenceValue">
        <th mat-header-cell *matHeaderCellDef>Ref Value *</th>
        <td mat-cell *matCellDef="let row">
          <input *ngIf="isEditing(row); else view" matInput [(ngModel)]="row.referenceValue" [disabled]="!isNewRow" />
          <ng-template #view>{{ row.referenceValue }}</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="referenceDesc">
        <th mat-header-cell *matHeaderCellDef>Description *</th>
        <td mat-cell *matCellDef="let row">
          <input *ngIf="isEditing(row); else view" matInput [(ngModel)]="row.referenceDesc" />
          <ng-template #view>{{ row.referenceDesc }}</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="productCode">
        <th mat-header-cell *matHeaderCellDef>Product Code</th>
        <td mat-cell *matCellDef="let row">
          <input *ngIf="isEditing(row); else view" matInput [(ngModel)]="row.productCode" />
          <ng-template #view>{{ row.productCode }}</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="assetTypeCode">
        <th mat-header-cell *matHeaderCellDef>Asset Type</th>
        <td mat-cell *matCellDef="let row">
          <input *ngIf="isEditing(row); else view" matInput [(ngModel)]="row.assetTypeCode" [disabled]="isAssetDisabled(row)" />
          <ng-template #view>{{ row.assetTypeCode }}</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="assetSubTypeCode">
        <th mat-header-cell *matHeaderCellDef>Asset Sub-Type</th>
        <td mat-cell *matCellDef="let row">
          <input *ngIf="isEditing(row); else view" matInput [(ngModel)]="row.assetSubTypeCode" [disabled]="isAssetDisabled(row)" />
          <ng-template #view>{{ row.assetSubTypeCode }}</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="include">
        <th mat-header-cell *matHeaderCellDef>Include *</th>
        <td mat-cell *matCellDef="let row">
          <mat-select *ngIf="isEditing(row); else view" [(ngModel)]="row.include">
            <mat-option value="Y">Y</mat-option>
            <mat-option value="N">N</mat-option>
          </mat-select>
          <ng-template #view>{{ row.include }}</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="exclude">
        <th mat-header-cell *matHeaderCellDef>Exclude *</th>
        <td mat-cell *matCellDef="let row">
          <mat-select *ngIf="isEditing(row); else view" [(ngModel)]="row.exclude">
            <mat-option value="Y">Y</mat-option>
            <mat-option value="N">N</mat-option>
          </mat-select>
          <ng-template #view>{{ row.exclude }}</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="isActive">
        <th mat-header-cell *matHeaderCellDef>Active *</th>
        <td mat-cell *matCellDef="let row">
          <mat-select *ngIf="isEditing(row); else view" [(ngModel)]="row.isActive" (ngModelChange)="onActiveChange(row)">
            <mat-option value="Y">Y</mat-option>
            <mat-option value="N">N</mat-option>
          </mat-select>
          <ng-template #view>{{ row.isActive }}</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="inactiveDate">
        <th mat-header-cell *matHeaderCellDef>Inactive Date</th>
        <td mat-cell *matCellDef="let row">{{ row.inactiveDate }}</td>
      </ng-container>

      <ng-container matColumnDef="application">
        <th mat-header-cell *matHeaderCellDef>Application *</th>
        <td mat-cell *matCellDef="let row">
          <mat-select *ngIf="isEditing(row); else view" [(ngModel)]="row.application" [disabled]="!isNewRow" panelClass="refcode-select-panel" class="refcode-select">
            <mat-option *ngFor="let app of applications" [value]="app">{{ app }}</mat-option>
          </mat-select>
          <ng-template #view><span class="application-name">{{ row.application }}</span></ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="alertCode">
        <th mat-header-cell *matHeaderCellDef>Alert Code</th>
        <td mat-cell *matCellDef="let row">
          <input *ngIf="isEditing(row); else view" matInput [(ngModel)]="row.alertCode" [disabled]="!isNewRow" />
          <ng-template #view>{{ row.alertCode }}</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="createdBy">
        <th mat-header-cell *matHeaderCellDef>Created By</th>
        <td mat-cell *matCellDef="let row">{{ row.createdBy }}</td>
      </ng-container>

      <ng-container matColumnDef="lastUpdatedBy">
        <th mat-header-cell *matHeaderCellDef>Last Updated By</th>
        <td mat-cell *matCellDef="let row">{{ row.lastUpdatedBy }}</td>
      </ng-container>

      <ng-container matColumnDef="actions" stickyEnd>
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="isEditing(row); else rowActions">
            <button mat-icon-button (click)="saveRow(row)" [disabled]="isSaving" title="Save"><mat-icon inline="true">check</mat-icon></button>
            <button mat-icon-button (click)="cancelEdit()" [disabled]="isSaving" title="Cancel"><mat-icon inline="true">close</mat-icon></button>
          </ng-container>
          <ng-template #rowActions>
            <button mat-icon-button (click)="startEdit(row)" title="Edit" [disabled]="!!editingRow">
              <mat-icon inline="true">edit</mat-icon>
            </button>
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <div *ngIf="dataSource.data.length === 0" class="text-muted m-t-10">
    No items on the review list yet.
  </div>
</div>
